<template>
  <div class="page">
    <div class="header">
      <div class="title">仓位计算器</div>
      <div class="risk">
        <el-input v-model="risk">
          <template #append>
            <el-button @click="riskhandle">R</el-button>
          </template>
        </el-input>
      </div>
      <div class="button">
        <el-button-group>
          <el-button icon="Plus" @click="add()"></el-button>
          <el-button icon="Refresh" @click="load()" :loading="loading"></el-button>
        </el-button-group>
      </div>
    </div>
    <div class="table">
      <el-table :data="list" border>
        <el-table-column label="杠杆" width="100" align="center">
          <template #default="{ row }">
            <div class='blue'>
              <el-input v-model="row.Lever" size="large" @change="change(row, 'lever')"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="本金" width="120" align="center">
          <template #default="{ row }">
            <span class='high'>{{ row.Amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成交额" width="120" align="center">
          <template #default="{ row }">
            <span class='high'>{{ row.TransAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="止损" width="120" align="center">
          <template #default="{ row }">
            <div class='red'>
              <el-input v-model="row.StopLoss" size="large" @input="input(row, 'StopLoss', 3)"
                @change="change(row, 'stopLoss')">
                <template #append>%</template>
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="止损金额" width="120" align="center">
          <template #default="{ row }">
            <div class='red'>
              <el-input v-model="row.StopLossAmount" size="large" @input="input(row, 'StopLossAmount', 1)"
                @change="change(row, 'stopLossAmount')">
                <template #append>$</template>
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="止盈" width="120" align="center">
          <template #default="{ row }">
            <div class='green'>
              <el-input v-model="row.TakeProfit" size="large" @input="input(row, 'TakeProfit', 3)"
                @change="change(row, 'takeProfit')">
                <template #append>%</template>
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="TakeProfitAmount" label="止盈金额" width="120" align="center">
          <template #default="{ row }">
            <div class='green'>
              <el-input v-model="row.TakeProfitAmount" size="large" @input="input(row, 'TakeProfitAmount', 1)"
                @change="change(row, 'takeProfitAmount')">
                <template #append>$</template>
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="" :show-overflow-tooltip="true">
          <template #default="{ row, $index }">
            <el-button icon="Select" size="large" @click="save(row)" :disabled="saveloading"></el-button>
            <el-button icon="Delete" size="large" @click="del(row, $index)" :disabled="deleteloading"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<style scoped>
.table>>>input {
  text-align: center !important;
  font-size: 16px;
  font-weight: bold;
}

.table>>>.el-button {
  padding: 12px 15px;
}

.table>>>.el-input__wrapper {
  background-color: #262727;
  box-shadow: none;
}

.table>>>.el-table--enable-row-hover .el-table__body tr:hover>td {
  background: #303133 !important;
}

.table>>>.el-input-group__append {
  box-shadow: none;
}

.header {
  display: flex;
  height: 30px;
  margin-bottom: 20px;
}

.title {
  width: 120px;
  font-size: 20px;
  font-weight: bold;
  color: #3da1d3;
  line-height: 26px;
}

.risk {
  margin-right: 10px;
  width: 105px;
}

.button {
  flex: 1;
  text-align: right;
}

.bold {
  font-size: 16px;
  font-weight: bold;
}

.table>>>.el-button--mini {
  padding: 7px 10px;
}

.table>>>.el-input-group__append {
  padding: 0 5px 0 0;
  font-size: 16px;
}

.high {
  font-weight: bold;
  font-size: 16px;
}

.low {
  font-weight: bold;
  color: #7c7c7c;
  font-size: 16px;
}

.low>>>.el-input__inner {
  color: #555555 !important;
}

.low>>>.el-input-group__append {
  color: #7c7c7c !important;
}

.red>>>.el-input__inner {
  color: #f56c6c !important;
}

.red>>>.el-input-group__append {
  color: #f56c6c !important;
}

.green>>>.el-input__inner {
  color: #67c23a !important;
}

.green>>>.el-input-group__append {
  color: #67c23a !important;
}

.blue>>>.el-input__inner {
  color: #e6a23c !important;
}
</style>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElNotification, ElMessage, ElMessageBox } from 'element-plus'
import Decimal from 'decimal.js'
import { Helper } from '@/service'
import Database from '@/service/database'

const loading = ref(false)
const saveloading = ref(false)
const deleteloading = ref(false)
const list = reactive([])
const risk = ref(0)

onMounted(async () => {
  load()
})

const load = async () => {
  try {
    loading.value = true

    //获取盈亏比设置
    let riskValue = await Database.select("Risk")
    if (riskValue && riskValue.length > 0) {
      risk.value = riskValue[0].RiskValue
    }

    let listValue = await Database.select("Calculation")
    list.splice(0, list.length, ...listValue)
    
    loading.value = false
  } catch (error) {
    loading.value = false
  }
}

const add = () => {
  let data = {
    Id: "",
    Symbol: "",
    Lever: 0,
    Amount: 0,
    TransAmount: 0,
    StopLoss: 0,
    TakeProfit: 0,
    StopLossAmount: 0,
    TakeProfitAmount: 0
  }
  list.push(data)
}

const save = async (data) => {
  saveloading.value = true

  let _lever = data.Lever
  let _amount = parseFloat(data.Amount)
  let _transAmount = parseFloat(data.TransAmount)
  let _stopLoss = parseFloat(data.StopLoss)
  let _takeProfit = parseFloat(data.TakeProfit)
  let _stopLossAmount = parseFloat(data.StopLossAmount)
  let _takeProfitAmount = parseFloat(data.TakeProfitAmount)

  try {
    data.Id = data.Id || Helper.NewId()
    await Database.insert('Calculation', {
      Id: data.Id,
      Lever: _lever,
      Amount: _amount,
      TransAmount: _transAmount,
      StopLoss: _stopLoss,
      TakeProfit: _takeProfit,
      StopLossAmount: _stopLossAmount,
      TakeProfitAmount: _takeProfitAmount
    })

    saveloading.value = false
    ElMessage.success('保存成功')
  } catch (error) {
    saveloading.value = false
    ElMessage.error('保存失败，系统异常')
  }
}

const change = (data, type) => {
  let lever = data.Lever
  let amount = data.Amount
  let transAmount = data.TransAmount
  let stopLoss = new Decimal(data.StopLoss).dividedBy(100)
  let takeProfit = new Decimal(data.TakeProfit).dividedBy(100)
  let stopLossAmount = data.StopLossAmount
  let takeProfitAmount = data.TakeProfitAmount

  //杠杆变化
  //只影响本金
  if (type === "lever") {
    if (lever <= 0) lever = 0
    if (lever == 0 || transAmount == 0) {
      amount = 0
      stopLossAmount = 0
      takeProfitAmount = 0
    } else {
      amount = Number(new Decimal(transAmount).dividedBy(lever).toDecimalPlaces(2, Decimal.ROUND_DOWN))
    }
  }

  //止损变化
  //除杠杆外影响所有
  if (type === "stopLoss") {
    if (stopLoss <= 0) stopLoss = 0
    if (stopLoss == 0 || lever == 0) {
      transAmount = 0
      amount = 0
      stopLossAmount = 0
      takeProfitAmount = 0
    } else {
      transAmount = Number(new Decimal(stopLossAmount).dividedBy(stopLoss).toDecimalPlaces(2, Decimal.ROUND_DOWN))
      amount = Number(new Decimal(transAmount).dividedBy(lever).toDecimalPlaces(2, Decimal.ROUND_DOWN))
      takeProfitAmount = Number(new Decimal(transAmount).times(takeProfit).toDecimalPlaces(2, Decimal.ROUND_DOWN))
    }
  }

  //止损金额变化
  if (type === "stopLossAmount") {
    if (stopLossAmount <= 0) stopLossAmount = 0
    if (stopLoss == 0 || lever == 0) {
      transAmount = 0
      amount = 0
      takeProfitAmount = 0
    } else {
      transAmount = Number(new Decimal(stopLossAmount).dividedBy(stopLoss).toDecimalPlaces(2, Decimal.ROUND_DOWN))
      amount = Number(new Decimal(transAmount).dividedBy(lever).toDecimalPlaces(2, Decimal.ROUND_DOWN))
      takeProfitAmount = Number(new Decimal(transAmount).times(takeProfit).toDecimalPlaces(2, Decimal.ROUND_DOWN))
    }
  }

  //止盈变化
  //只影响止盈金额
  if (type === "takeProfit") {
    if (takeProfit <= 0) takeProfit = 0
    if (takeProfit == 0 || lever == 0) {
      takeProfitAmount = 0
    } else {
      takeProfitAmount = Number(new Decimal(transAmount).times(takeProfit).toDecimalPlaces(2, Decimal.ROUND_DOWN))
    }
  }

  //止盈金额变化
  //只影响止盈
  if (type === "takeProfitAmount") {
    if (takeProfitAmount <= 0) takeProfitAmount = 0
    if (transAmount == 0 || lever == 0) {
      takeProfit = 0
    } else {
      takeProfit = Number((new Decimal(takeProfitAmount).dividedBy(transAmount)).toDecimalPlaces(3, Decimal.ROUND_DOWN))
    }
  }
  data.Lever = lever
  data.Amount = amount
  data.TransAmount = transAmount
  data.StopLoss = Number(new Decimal(stopLoss).times(100))
  data.TakeProfit = Number(new Decimal(takeProfit).times(100))
  data.StopLossAmount = stopLossAmount
  data.TakeProfitAmount = takeProfitAmount
}

const riskhandle = () => {
  if (isNaN(risk.value)) {
    ElMessage.error('请输入数字')
    return
  }

  list.forEach(item => {
    if (item.Status == 0 || isNaN(item.StopLoss)) return
    item.TakeProfit = Number(new Decimal(item.StopLoss).times(risk.value).toDecimalPlaces(2, Decimal.ROUND_DOWN))

    if (item.TakeProfit < 0) item.TakeProfit = 0
    if (item.TakeProfit == 0 || item.lever == 0) {
      item.TakeProfitAmount = 0
    } else {
      item.TakeProfitAmount = Number(new Decimal(item.TransAmount).times(item.TakeProfit).dividedBy(100).toDecimalPlaces(2, Decimal.ROUND_DOWN))
    }
  })

  ElNotification({
    message: `止盈已重置`,
    type: 'info',
  })
}

const del = (data, index) => {
  if (!data.Id) {
    list.splice(index, 1)
    return
  }

  ElMessageBox.confirm('你确定删除?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    deleteloading.value = true
    await Database.delete('Calculation', data.Id)
    list.splice(index, 1)
    deleteloading.value = false
  }).catch((error) => {
    deleteloading.value = false
    if (error !== 'cancel') ElMessage.error('删除失败，系统异常')
  })
}

const input = (data, type, decimals) => {
  // 正则表达式：匹配整数或最多decimals位小数
  const regex = new RegExp(`^\\d*\\.?\\d{0,${decimals}}$`)
  if (!regex.test(data[type])) {
    // 如果输入的值不符合规则，则将其恢复为之前的值
    data[type] = data[type].slice(0, -1)
  }
}

</script>